export const getEmbedUrl = (url) => {
	let videoId;

	// Handle different YouTube URL formats
	if (url.includes('v=')) {
		videoId = url.split('v=')[1];
		// Handle additional parameters after video ID
		const ampersandPosition = videoId.indexOf('&');
		if (ampersandPosition !== -1) {
			videoId = videoId.substring(0, ampersandPosition);
		}
	} else if (url.includes('youtu.be/')) {
		videoId = url.split('youtu.be/')[1];
	}

	// Add additional parameters for better playback reliability
	return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&enablejsapi=1`;
};
